import { FunctionComponent } from 'react';
import HeaderIconLabel from 'components/UI/HeaderIconLabel';
import doggyIcon from './assets/ai-agent-doggy.png';
import styles from './AiAgentLauncher.module.scss';

interface Props {
    onClick: () => void;
}

const AiAgentLauncher: FunctionComponent<Props> = ({ onClick }) => {
    return (
        <HeaderIconLabel text="AI Agent">
            <button
                type="button"
                className={styles.button}
                aria-label="AI Agent"
                onClick={onClick}
            >
                <img
                    src={doggyIcon}
                    alt=""
                    width={32}
                    height={34}
                    className={styles.icon}
                />
            </button>
        </HeaderIconLabel>
    );
};

export default AiAgentLauncher;
